module.exports = __webpack_public_path__ + "img/sign-in-redirect.8b9de6e5.svg";